// Email validation
export const isValidEmail = (email: string): boolean => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email) && email.length <= 50;
};

// Phone validation for international phone numbers
export const isValidPhone = (phone: string): boolean => {
  // react-international-phone returns formatted phone like "+1 (555) 123-4567"
  // Remove all non-digit characters except the leading +
  const cleanPhone = phone.replace(/[^\d+]/g, '');
  
  // Must start with + and have at least 10 digits total (including country code)
  return cleanPhone.startsWith('+') && cleanPhone.length >= 10 && cleanPhone.length <= 15;
};

// Get clean phone number for API (digits only with country code)
export const getCleanPhoneNumber = (phone: string): string => {
  let cleaned = phone.replace(/[^\d+]/g, '');

  if (cleaned.startsWith('+9720')) {
    cleaned = '+972' + cleaned.slice(5);
  }

  return cleaned;
};


// Name validation
export const isValidName = (name: string): boolean => {
  return name.trim().length > 0 && name.trim().length <= 50;
};

// Zip code validation
export const isValidZipCode = (zipCode: string): boolean => {
  return zipCode.trim().length > 0;
};

// Ticket number validation
export const isValidTicketNumber = (ticketNumber: string): boolean => {

  const trimmed = ticketNumber.trim();
  return trimmed.length >= 2 &&   
         trimmed.length <= 60 && 
         /^[0-9]+$/.test(trimmed);
};

// Car plate validation
export const isValidCarPlate = (carPlate: string): boolean => {
  const trimmed = carPlate.trim();
  return trimmed.length >= 2 && 
         trimmed.length <= 10 && 
         /^[A-Za-z0-9]+$/.test(trimmed);
};



/**
 * Converts an ISO 8601 date string to a custom, localized format in UTC.
 * @param {string} isoString The ISO 8601 date string (e.g., "2025-08-19T22:25:22Z").
 * @returns {string} The formatted date string (e.g., "Aug 20, 2025, 01:25 AM").
 */
export const formatDate = (isoString: string): string => {
  // 1. Create a Date object from the input string.
  // This automatically handles both UTC ('Z') and timezone offset strings.
  const date = new Date(isoString);

  // 2. Define the formatting options for the Intl.DateTimeFormat object.
  const options: Intl.DateTimeFormatOptions = {
    month: 'short', // 'Aug'
    day: '2-digit', // '20'
    year: 'numeric', // '2025'
    hour: '2-digit', // '01'
    minute: '2-digit', // '25'
    hour12: true, // Use AM/PM
    timeZone: 'UTC' // Crucially, format the time based on UTC
  };

  // 3. Create a formatter instance with the desired locale and options.
  // 'en-US' is used here to get the 'Aug' month abbreviation.
  const formatter = new Intl.DateTimeFormat('en-US', options);

  // 4. Use the formatter to format the Date object.
  const formattedString = formatter.format(date);

  return formattedString;
}